
/* global gdAlertify */
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import axiosInstance from "../config/axiosConfig"; // Asegúrate de tener tu configuración de axios
import BuscarPaciente from "./components/BuscarPaciente";
import Calendario from "./components/Calendario";
import { formatDateTime, formatMonthDate, formatDate } from "../utils/utils";
import { isNullOrUndef } from "chart.js/helpers";

const BitacoraPaciente = () => {
    const [pacienteInfo, setPacienteInfo] = useState(null);
    const [visitas, setVisitas] = useState([]);
    const [enfermeria, setEnfermeria] = useState([]);
    const [fechasVisitas, setFechasVisitas] = useState([]);
    const [filtradasVisitas, setFiltradasVisitas] = useState([]);
    const [detalleVisita, setDetalleVisita] = useState(null);
    const [startMonth, setStartMonth] = useState(new Date().toISOString().slice(0, 7));
    const handleSeleccionaPaciente = async (paciente) => {
        setPacienteInfo(paciente);
    };
    const [selectedDate, setSelectedDate] = useState(null);

    const handleDateSelect = (date) => {
        setSelectedDate(date.format('YYYY-MM-DD'));
        let visitasFiltradas = visitas.visitas.filter(visita => visita.fecha_visita === date.format('YYYY-MM-DD'));
        setFiltradasVisitas(visitasFiltradas);
    };

    const handleMonthChange = (e) => {
        setStartMonth(e.target.value); // Cambiar el mes seleccionado
    };

    const verVisita = (visitaID) => {
        let visitaDetalle = visitas.visitas.filter(visita => visita.visitaID === visitaID && visita.tipo_visita == 1)[0];
        setDetalleVisita(visitaDetalle);
    }

    const verEnfermeria = (visitaID) => {
        let visitaDetalle = visitas.visitas.filter(visita => visita.visitaID === visitaID && visita.tipo_visita == 2)[0];
        setDetalleVisita(visitaDetalle);
    }

    const renderDetalle = (titulo, valor) => {
        // if (valor) {
        return (
            <div key={titulo} className="mb-3 col-6">
                <h5>{titulo}</h5>
                <p>{valor}</p>
            </div>
        );
        // }
        // return null; // Si el valor es vacío o nulo, no lo renderiza
    };

    const eliminarVisita = (visitaID, tipo) => {
        gdAlertify.confirm({
            title: 'Eliminar visita',
            message: '¿Está seguro de que desea eliminar esta visita?',
            onConfirm: async () => {
                try {
                    const response = await axiosInstance.post('paciente/eliminar-visita', { visitaId: visitaID, tipo: tipo });

                    if (!response.data.error) {
                        gdAlertify.notify('Visita eliminada correctamente', 'success');
                        setDetalleVisita(null);
                        buscar();
                    } else {
                        gdAlertify.notify(response.data.message || 'Error al eliminar la visita', 'error');
                    }
                } catch (error) {
                    gdAlertify.notify('Error al eliminar la visita', 'error');
                }
            },
            onCancel: () => {
                gdAlertify.notify('Acción cancelada', 'info');
            }
        });
    };

    const navigate = useNavigate();
    const editarVisita = (visitaID, tipo) => {
        gdAlertify.confirm({
            title: 'Editar visita',
            message: '¿Está seguro de que desea editar esta visita?',
            onConfirm: async () => {
                if (tipo == 1) {
                    navigate('/form-visita/' + visitaID);
                } else {
                    navigate('/form-ingreso-enfermeria/' + visitaID);
                }
            },
            onCancel: () => {
                gdAlertify.notify('Acción cancelada', 'info');
            }
        });
    };

    const authToken = localStorage.getItem('authToken');

    const decodeJWT = (token) => {
        try {
            const base64Url = token.split('.')[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
            return JSON.parse(jsonPayload);
        } catch (error) {
            return null;
        }
    };
    const decodedToken = authToken ? decodeJWT(authToken) : null;
    const usuarioActualID = decodedToken.id

    const formatearFechaConMesTexto = (fechaISO) => {
        const meses = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];
        const [anio, mes, dia] = fechaISO.split("-");
        return `${parseInt(dia)}/${meses[parseInt(mes) - 1]}/${anio}`;
    };

    const buscar = async () => {
        if (isNullOrUndef(pacienteInfo)) {
            gdAlertify.notify('Seleccione paciente', 'error');
            return;
        }
        gdAlertify.showLoader()
        try {
            const solicitudes = await axiosInstance.post("/paciente/visitas",
                {
                    pacienteID: pacienteInfo.id,
                    periodo: startMonth
                }
            );
            let fechasVisitas = [];
            setVisitas(solicitudes.data.data);
            if (solicitudes.data.data.visitas && solicitudes.data.data.visitas.length > 0) {
                fechasVisitas = solicitudes.data.data.visitas.map(visita => visita.fecha_visita);
            } else {
                setFiltradasVisitas([]);
                setDetalleVisita(null);
            }
            setFechasVisitas(fechasVisitas);
            gdAlertify.hideLoader()
        } catch (error) {
            gdAlertify.hideLoader()
            console.error("Error al obtener los datos: ", error);
        }
    };

    return (
        <div className="container mt-5">
            <div className="card p-4">
                <h3 className="mb-4">Bitacora paciente</h3>
                <div className="mb-3">
                    <div className="row">
                        <div className="border p-4 mb-4 col-12">
                            <div className="row g-3 d-flex justify-content-between">
                                <div className="col-md-6">
                                    <BuscarPaciente onSelect={handleSeleccionaPaciente} onClear={handleSeleccionaPaciente} conPaciente={true} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label fw-bold">Mes</label>
                                    <input
                                        type="month"
                                        className="form-control"
                                        placeholder="Mes de inicio"
                                        value={startMonth}
                                        onChange={handleMonthChange} // Cambiar mes
                                    />
                                </div>
                                <div className="col-md-12 d-flex justify-content-center">
                                    <button className="btn btn-primary" onClick={buscar}>
                                        Buscar
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="border p-4 mb-4 col-4">
                            <div className="col-md-12">
                                <label className="form-label fw-bold">Paciente</label>
                                <p id="nombrePaciente" className="form-control-plaintext">
                                    {pacienteInfo
                                        ? `${pacienteInfo.nombres} ${pacienteInfo.apellidoPaterno} ${pacienteInfo.apellidoMaterno}`
                                        : ""}
                                </p>
                            </div>
                        </div>
                        <div className="border p-4 mb-4 col-8">
                            {visitas.indicadores ?
                                <div className="row">
                                    <div className="col-2">
                                        <label className="form-label fw-bold">Total Visitas</label>
                                        <p>{visitas.indicadores.total_visitas}</p>
                                    </div>
                                    <div className="col-2">
                                        <label className="form-label fw-bold">Visitas Presenciales</label>
                                        <p>{visitas.indicadores.visitas_presenciales}</p>
                                    </div>
                                    <div className="col-2">
                                        <label className="form-label fw-bold">Visitas Presenciales Fuera de Santiago</label>
                                        <p>{visitas.indicadores.visitas_presenciales_fuera}</p>
                                    </div>
                                    <div className="col-2">
                                        <label className="form-label fw-bold">Visitas Telefonicas</label>
                                        <p>{visitas.indicadores.visitas_telefonicas}</p>
                                    </div>
                                    <div className="col-2">
                                        <label className="form-label fw-bold">Ingresos Enfermeria</label>
                                        <p>{visitas.indicadores.ingreso_enfermeria}</p>
                                    </div>
                                </div>
                                : ''}
                        </div>
                        <div className="border p-4 mb-4 col-12">
                            <Calendario
                                validDates={fechasVisitas}
                                onDateSelect={handleDateSelect}
                                displayDate={`${startMonth}-01`}
                            />
                        </div>
                        <div className="border p-4 mb-4 col-2">
                            <h4>Visitas</h4>
                            {filtradasVisitas.map((visita, index) => (
                                <button
                                    key={visita.visitaID + '-' + visita.tipo_visita}
                                    className={`btn ${visita.tipo_visita == 1 ? "btn-primary" : "btn-success"} mb-2 w-100 text-start`}
                                    onClick={() => {
                                        if (visita.tipo_visita == 1) {
                                            verVisita(visita.visitaID);
                                        } else if (visita.tipo_visita == 2) {
                                            verEnfermeria(visita.visitaID);
                                        }
                                    }}
                                >
                                    <div>{(visita.nombre_paciente || '') + ' ' + (visita.apellido_paciente || '')}</div>
                                    <small>{visita.tipo_visita == 1 ? "Visita" : "Enfermería"} {index + 1}</small>
                                </button>
                            ))}
                        </div>
                        <div className="border p-4 mb-4 col-10">
                            <div className="d-flex align-items-center mb-3">
                                <h4>Detalle</h4>
                                {detalleVisita && (detalleVisita.usuarioID == usuarioActualID || detalleVisita.usuario_id == usuarioActualID) && (
                                    <div className="d-flex">
                                        <button
                                            className="btn btn-danger justify-content-end ms-auto"
                                            onClick={() => eliminarVisita(detalleVisita.visitaID, detalleVisita.tipo_visita)}
                                        >
                                            Eliminar {detalleVisita.tipo_visita === 1 ? "Visita" : "Enfermería"}
                                        </button>

                                        <button
                                            className="btn btn-success justify-content-end ms-auto"
                                            onClick={() => editarVisita(detalleVisita.visitaID, detalleVisita.tipo_visita)}
                                        >
                                            Editar {detalleVisita.tipo_visita === 1 ? "Visita" : "Enfermería"}
                                        </button>
                                    </div>
                                )}
                            </div>
                            {detalleVisita ? (
                                <div className="row">
                                    {detalleVisita.tipo_visita === 1 ? (
                                        <>
                                            {renderDetalle('Enfermero/a Visita', detalleVisita.usuario_visita)}
                                            {renderDetalle('Nombre Paciente', detalleVisita.nombre_paciente + ' ' + detalleVisita.apellido_paciente)}
                                            {renderDetalle('Fecha de la Visita', formatDate(detalleVisita.fecha_visita))}
                                            {renderDetalle('Mes de la Visita', formatMonthDate(detalleVisita.fecha_visita))}
                                            {renderDetalle('Tipo de Visita', detalleVisita.tipo_visita === 1 ? 'Presencial' : 'Telefónico')}
                                            {renderDetalle('Diagnóstico', detalleVisita.diagnostico)}
                                            {renderDetalle('Estado de Salud', detalleVisita.estado_salud)}
                                            {renderDetalle('Estado Cognitivo', detalleVisita.estado_cognitivo)}
                                            {renderDetalle('Lenguaje', detalleVisita.habla)}
                                            {renderDetalle('Movilidad', detalleVisita.movimiento)}
                                            {renderDetalle('Antecedentes Médicos', detalleVisita.antecedentes_medicos)}
                                            {renderDetalle('Evolución', detalleVisita.examen_fisico)}
                                            {renderDetalle('Medicamentos y Horarios', detalleVisita.medicamento_horarios)}
                                            {renderDetalle('Rutinas y/o actividades del paciente', detalleVisita.rutina)}
                                            {renderDetalle('Plan de Atención', detalleVisita.plan_atencion)}
                                            {renderDetalle('Observación paciente', detalleVisita.observacion)}
                                            {detalleVisita.nombre_auxiliar_visita && renderDetalle('Auxiliar', detalleVisita.nombre_auxiliar_visita)}
                                            {detalleVisita.observacion_auxiliar && renderDetalle('Observación Auxiliar', detalleVisita.observacion_auxiliar)}
                                        </>
                                    ) : (
                                        <>
                                            {renderDetalle('Enfermero/a Visita', detalleVisita.nombre + ' ' + detalleVisita.apellido)}
                                            {renderDetalle('Nombre Paciente', detalleVisita.nombre_paciente + ' ' + (detalleVisita.apellido_paciente || ''))}
                                            {renderDetalle('Fecha de Registro', formatDateTime(detalleVisita.fechaRegistro))}
                                            {renderDetalle('Mes de Registro', formatMonthDate(detalleVisita.fechaRegistro))}
                                            {renderDetalle('Estado de Cama', detalleVisita.estadoCama)}
                                            {renderDetalle('Estado de Casa', detalleVisita.estadoCasa)}
                                            {renderDetalle('Estado Cognitivo', detalleVisita.estadoCognitivo)}
                                            {renderDetalle('Estado de Salud', detalleVisita.estadoSalud)}
                                            {renderDetalle('Estado de Habitación', detalleVisita.estadoHabitacion)}
                                            {renderDetalle('Evaluación Domicilio', detalleVisita.evaluacionDomicilio)}
                                            {renderDetalle('Evolución', detalleVisita.examenFisico)}
                                            {renderDetalle('Asistencia Adicional', detalleVisita.asistenciaAdicional)}
                                            {renderDetalle('Lenguaje', detalleVisita.capacidadHablar)}
                                            {renderDetalle('Movilidad', detalleVisita.capacidadMoverse)}
                                            {renderDetalle('Medicamentos', detalleVisita.medicamentos)}
                                            {renderDetalle('Necesidades Especiales', detalleVisita.necesidadesEspeciales)}
                                            {renderDetalle('Plan de Atención', detalleVisita.planAtencion)}
                                            {renderDetalle('Riesgos', detalleVisita.riesgos)}
                                            {renderDetalle('Rutinas', detalleVisita.rutinas)}
                                        </>
                                    )}

                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BitacoraPaciente;
